import { ClientAPI } from '@/redux/api';
import { UserPracticeAreaResponse } from '@/@types/client-api';

const invalidatesUserPracticeAreasTags = [
  { type: 'Library', id: 'UserPracticeAreas' },
  { type: 'CreditPlans', id: 'LIST' }
] as const;

const userPracticeAreasEndpoints = ClientAPI.injectEndpoints({
  endpoints: builder => ({
    getUserPracticeAreas: builder.query<UserPracticeAreaResponse, void>({
      query: () => ({
        url: '/user/practice-areas',
        method: 'GET'
      }),
      providesTags: [{ type: 'Library', id: 'UserPracticeAreas' }]
    }),
    followPracticeAreas: builder.mutation<void, string[]>({
      query: body => ({
        url: `/user/practice-areas/follow`,
        method: 'POST',
        body
      }),
      invalidatesTags: invalidatesUserPracticeAreasTags
    }),
    unfollowPracticeAreas: builder.mutation<void, string[]>({
      query: body => ({
        url: `/user/practice-areas/unfollow`,
        method: 'POST',
        body
      }),
      invalidatesTags: invalidatesUserPracticeAreasTags
    }),
    followPracticeAreasByCategoryId: builder.mutation<void, string[]>({
      query: body => ({
        url: `/user/practice-areas/by-categoryid/follow`,
        method: 'POST',
        body
      }),
      invalidatesTags: invalidatesUserPracticeAreasTags
    }),
    unfollowPracticeAreasByCategoryId: builder.mutation<void, string[]>({
      query: body => ({
        url: `/user/practice-areas/by-categoryid/unfollow`,
        method: 'POST',
        body
      }),
      invalidatesTags: invalidatesUserPracticeAreasTags
    })
  })
});

export const {
  useGetUserPracticeAreasQuery,
  useLazyGetUserPracticeAreasQuery,
  useFollowPracticeAreasMutation,
  useUnfollowPracticeAreasMutation,
  useFollowPracticeAreasByCategoryIdMutation,
  useUnfollowPracticeAreasByCategoryIdMutation
} = userPracticeAreasEndpoints;

export default userPracticeAreasEndpoints;
